(function(){
  'use strict';

  function collectionHandle(value){
    try{
      var path = new URL(value, window.location.origin).pathname;
      var match = path.match(/\/collections\/([^\/?#]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    }catch(e){
      var fallback = String(value || '').match(/\/collections\/([^\/?#]+)/i);
      return fallback ? decodeURIComponent(fallback[1]).toLowerCase() : '';
    }
  }

  function init(){
    if(window.location.pathname.indexOf('/collections/') === -1) return;

    var root = document.querySelector('[data-pmy-header-2026]');
    if(!root) return;

    var category = root.querySelector('#pmy-platform-category');
    var oldButton = root.querySelector('#pmy-platform-search-btn');
    var dateInput = root.querySelector('#pmy-platform-date');
    var peopleInput = root.querySelector('#pmy-platform-people');
    if(!category || !oldButton) return;

    var currentHandle = collectionHandle(window.location.pathname);
    var currentOption = Array.from(category.options).find(function(option){
      return option.value && collectionHandle(option.value) === currentHandle;
    });

    if(currentOption){
      var service = currentOption.getAttribute('data-service');
      var serviceButton = service ? root.querySelector('.pmy-platform-vertical[data-service="' + service + '"]') : null;
      if(serviceButton && !serviceButton.classList.contains('is-active')) serviceButton.click();

      category.value = currentOption.value;
      var visibleValue = root.querySelector('.pmy-search-what .pmy-field-value');
      if(visibleValue) visibleValue.textContent = currentOption.textContent.trim();
    }

    var button = oldButton.cloneNode(true);
    oldButton.parentNode.replaceChild(button, oldButton);

    button.addEventListener('click', function(){
      var target = category.value || window.location.pathname;

      try{
        var url = new URL(target, window.location.origin);
        var collectionIndex = window.location.pathname.indexOf('/collections/');
        var localePrefix = collectionIndex > 0 ? window.location.pathname.slice(0, collectionIndex) : '';

        if(localePrefix && url.origin === window.location.origin && url.pathname.indexOf('/collections/') === 0){
          url.pathname = localePrefix + url.pathname;
        }

        var currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach(function(value, key){
          if(key !== 'date' && key !== 'people') url.searchParams.set(key, value);
        });

        if(dateInput && dateInput.value) url.searchParams.set('date', dateInput.value);
        else url.searchParams.delete('date');

        if(peopleInput && peopleInput.value) url.searchParams.set('people', peopleInput.value);
        else url.searchParams.delete('people');

        window.location.assign(url.toString());
      }catch(e){
        window.location.assign(target);
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ window.setTimeout(init, 0); }, { once: true });
  }else{
    window.setTimeout(init, 0);
  }
})();